var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.125C2 5.03098 2.4346 3.98177 3.20818 3.20818C3.98177 2.4346 5.03098 2 6.125 2H30.875C31.969 2 33.0182 2.4346 33.7918 3.20818C34.5654 3.98177 35 5.03098 35 6.125V30.875C35 31.969 34.5654 33.0182 33.7918 33.7918C33.0182 34.5654 31.969 35 30.875 35H6.125C5.03098 35 3.98177 34.5654 3.20818 33.7918C2.4346 33.0182 2 31.969 2 30.875V6.125Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 16.437V26.7495",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.2495V10.2701",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5005 26.7495V16.437",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7505 26.7495V20.562C26.7505 19.468 26.3159 18.4188 25.5423 17.6452C24.7687 16.8716 23.7195 16.437 22.6255 16.437C21.5315 16.437 20.4823 16.8716 19.7087 17.6452C18.9351 18.4188 18.5005 19.468 18.5005 20.562",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7b0739feaea4bd0dba4486a73fb27f34.svg";
export { ForwardRef as ReactComponent };